// extracted by mini-css-extract-plugin
module.exports = {"container":"recommended_questions_container__Vugp_","title":"recommended_questions_title__03Vi9","chevron":"recommended_questions_chevron__Y4X0y"};